import React from "react";

/**
 * Perla Music official logo — extracted from client-provided PDF.
 * Assets in /public:
 *  - perla-logo-light.png (P + wordmark in black — for light backgrounds)
 *  - perla-logo-dark.png  (P + wordmark in white — for dark backgrounds)
 *  - perla-symbol.png     (P symbol only, transparent — for compact/icon)
 */
export const PerlaLogo = ({ compact = false, light = false, className = "", height = 36 }) => {
  const symbolOnly = compact;
  const src = symbolOnly
    ? "/perla-symbol.png"
    : light
      ? "/perla-logo-dark.png"
      : "/perla-logo-light.png";
  const alt = "Perla Music";
  const style = symbolOnly ? { height, width: height } : { height };
  return (
    <img
      src={src}
      alt={alt}
      className={`shrink-0 select-none ${className}`}
      style={style}
      draggable="false"
      data-testid="perla-logo"
    />
  );
};
